<template lang="html">
  <div>
    <v-btn color="primary" class="mt-4" @click="handleAdd">
      {{ addButtonText }}
    </v-btn>
    <v-simple-table>
      <thead>
        <tr>
          <th v-for="(header, i) in headers" :key="`header-${i}`">
            {{ headerTitle(header) }}
          </th>
          <th v-if="displayOptions"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="record in records" :key="record.id">
          <td v-for="(header, i) in headers" :key="`row-${i}-record-${record.id}`">
            <slot v-if="header.key && hasSlot(header.key)" :name="header.key" :val="rowValue(record, header)">
            </slot>
            <template v-else>
              {{ rowValue(record, header) }}
            </template>
          </td>
          <td v-if="displayOptions">
            <v-icon v-if="patchServiceAction" @click="handleEdit(record.id)" class="mr-4" color="edit">mdi-pencil</v-icon>
            <v-icon v-if="deleteServiceAction" @click="handleDelete(record.id)" color="delete">mdi-trash-can-outline</v-icon>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <BaseFormDialog
      v-if="postServiceAction"
      :dialog.sync="addDialog"
      :custom-resource="resource"
      custom-action="new"
      :post-service-action="postServiceAction"
      :template-service-action="templateServiceAction"
      v-bind="createDialogProps"
      @post="reload"
    />
    <BaseFormDialog
      v-if="selectedRecordId && patchServiceAction && getServiceAction"
      :dialog.sync="editDialog"
      :custom-resource="resource"
      custom-action="edit"
      :custom-record-id="selectedRecordId"
      :get-record-service-action="getServiceAction"
      :patch-service-action="patchServiceAction"
      v-bind="editDialogProps"
      @patch="reload"
    />
    <BaseDeleteDialog
      v-if="selectedRecordId && deleteServiceAction"
      v-model="deleteDialog"
      :resource-id.sync="selectedRecordId"
      :delete-service-action="deleteServiceAction"
      @delete="reload"
    />
  </div>
</template>

<script>
import { snakeCase, capitalize, get } from 'lodash';
import hasSlot from '@/mixins/hasSlot';

export default {
  mixins: [hasSlot],
  props: {
    resource: {
      type: String,
      required: true,
    },
    indexServiceAction: {
      type: Function,
      required: true,
    },
    getServiceAction: {
      type: Function,
      required: false,
    },
    patchServiceAction: {
      type: Function,
      required: false,
    },
    postServiceAction: {
      type: Function,
      required: false,
    },
    templateServiceAction: {
      type: Function,
      required: false,
    },
    deleteServiceAction: {
      type: Function,
      required: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    addText: {
      type: String,
      required: false,
    },
    createDialogProps: {
      type: Object,
      default: () => ({}),
    },
    editDialogProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      records: [],
      selectedRecordId: undefined,
      addDialog: false,
      editDialog: false,
      deleteDialog: false,
    };
  },
  created() {
    this.getRecords();
  },
  computed: {
    displayOptions() {
      return this.patchServiceAction || this.deleteServiceAction;
    },
    addButtonText() {
      return this.addText || capitalize(this.$t('general.add'));
    },
  },
  methods: {
    async getRecords() {
      var loading = await this.$store.dispatch('load');
      try {
        const { data } = await this.indexServiceAction(
          {
            page: {
              limit: 100,
            },
          }
        );
        this.records = data;
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.dispatch('unload', loading);
      }
    },
    handleAdd() {
      this.addDialog = true;
    },
    handleEdit(recordId) {
      this.selectedRecordId = recordId;
      this.editDialog = true;
    },
    handleDelete(recordId) {
      this.selectedRecordId = recordId;
      this.deleteDialog = true;
    },
    headerTitle(header) {
      if (header?.text) return header.text;
      return capitalize(this.$t(`attributes.${this.resource}.${snakeCase(header.key)}`));
    },
    rowValue(record, header) {
      if (header?.convert) {
        return header.convert( get(record, header?.key));
      } else {
        return get(record, header?.key);
      }
    },
    reload() {
      this.getRecords();
      this.$emit('reload', true);
    },
  },
}
</script>

<style lang="css" scoped>
</style>